<template>
  <div class="pricing-page maxwidth">
    <CardSection class="maxWidth" :title="$t('pricing.title')" :text="$t('pricing.text')" />
    <div class="carousel-pricing" ref="carousel" @scroll="onScroll" :style="carouselPaddingStyle">
      <div v-for="(card, i) in cards" :key="i" :class="['pricing-card', { active: i === currentIndex, 'inactive': i !== currentIndex }]">
        <div v-if="i === bestSellerIndex" class="bestseller-tag">{{ $t('pricing.bestSeller') }}</div>
        <div class="header">
          <div><span class="priceText">{{ card.priceText }}</span></div>
          <div><span class="gradient-text2 price">{{ card.price }}</span></div>
        </div>
        <div class="header2">
          <div><span class="gradient-text serviceTitle">{{ card.service }}</span></div>
          <div><span class="titlePack">{{ card.title }}</span></div>
        </div>
        <div class="features">
          <ul>
            <li v-for="(f, j) in card.features" :key="j">✔ {{ f }}</li>
          </ul>
        </div>
        <div class="options">
          <strong @click="toggleOptions(i)" style="cursor:pointer;">
            {{ $t('pricing.options') }}
            <span :class="['arrow', { open: optionsOpen[i] }]">⤵</span>
          </strong>
          <transition name="fade">
            <ul v-if="optionsOpen[i]" class="options">
              <li v-for="(o, j) in card.options" :key="j">{{ o }}</li>
            </ul>
          </transition>
        </div>
        <button class="choose-offer-btn" @click="chooseOffer(i)">{{ $t('pricing.chooseOffer') }}</button>
      </div>
    </div>
    <div class="carousel-bullets">
      <span v-for="(card, i) in cards" :key="i" :class="['bullet', { active: i === currentIndex }]" @click="scrollToCard(i)"></span>
    </div>
          <FooterComponent class="cardSection scroll-hidden" v-scroll="'scroll-hidden'"/>
  </div>
</template>

<script>
import CardSection from '../components/CardSectionComponent.vue';
import FooterComponent from '../components/FooterComponent.vue';
export default {
  name: 'PricingPage',
  components: { CardSection,FooterComponent },
  data() {
    return {
      currentIndex: 0,
      cardWidth: 350,
      gap: 24,
      containerPadding: 0,
      optionsOpen: [false, false, false, false],
      bestSellerIndex: 1, // Ajout de l'index du Best Seller (2Pack)
    };
  },
  computed: {
    cards() {
      return [
        {
          title: this.$t('pricing.backpack.title'),
          service: this.$t('pricing.backpack.service'),
          priceText: this.$t('pricing.backpack.priceText'),
          price: this.$t('pricing.backpack.price'),
          features: [
            this.$t('pricing.backpack.features.0'),
            this.$t('pricing.backpack.features.1'),
            this.$t('pricing.backpack.features.2'),
            this.$t('pricing.backpack.features.3'),
            this.$t('pricing.backpack.features.4'),
            this.$t('pricing.backpack.features.5'),
            this.$t('pricing.backpack.features.6'),
          ],
          options: [
            this.$t('pricing.backpack.options.0'),
            this.$t('pricing.backpack.options.1'),
            this.$t('pricing.backpack.options.2'),
            this.$t('pricing.backpack.options.3'),
            this.$t('pricing.backpack.options.4'),
          ]
        },
        {
          title: this.$t('pricing.twopack.title'),
          service: this.$t('pricing.twopack.service'),
          priceText: this.$t('pricing.twopack.priceText'),
          price: this.$t('pricing.twopack.price'),
          features: [
            this.$t('pricing.twopack.features.0'),
            this.$t('pricing.twopack.features.1'),
            this.$t('pricing.twopack.features.2'),
            this.$t('pricing.twopack.features.3'),
            this.$t('pricing.twopack.features.4'),
            this.$t('pricing.twopack.features.5'),
            this.$t('pricing.twopack.features.6'),
            this.$t('pricing.twopack.features.7'),
          ],
          options: [
            this.$t('pricing.twopack.options.0'),
            this.$t('pricing.twopack.options.1'),
            this.$t('pricing.twopack.options.2'),
            this.$t('pricing.twopack.options.3'),
          ]
        },
        {
          title: this.$t('pricing.sixpack.title'),
          service: this.$t('pricing.sixpack.service'),
          priceText: this.$t('pricing.sixpack.priceText'),
          price: this.$t('pricing.sixpack.price'),
          features: [
            this.$t('pricing.sixpack.features.0'),
            this.$t('pricing.sixpack.features.1'),
            this.$t('pricing.sixpack.features.2'),
            this.$t('pricing.sixpack.features.3'),
            this.$t('pricing.sixpack.features.4'),
            this.$t('pricing.sixpack.features.5'),
            this.$t('pricing.sixpack.features.6'),
          ],
          options: [
            this.$t('pricing.sixpack.options.0'),
            this.$t('pricing.sixpack.options.1'),
            this.$t('pricing.sixpack.options.2'),
            this.$t('pricing.sixpack.options.3'),
          ]
        },
        {
          title: this.$t('pricing.jetpack.title'),
          service: this.$t('pricing.jetpack.service'),
          priceText: this.$t('pricing.jetpack.priceText'),
          price: this.$t('pricing.jetpack.price'),
          features: [
            this.$t('pricing.jetpack.features.0'),
            this.$t('pricing.jetpack.features.1'),
            this.$t('pricing.jetpack.features.2'),
            this.$t('pricing.jetpack.features.3'),
            this.$t('pricing.jetpack.features.4'),
            this.$t('pricing.jetpack.features.5'),
            this.$t('pricing.jetpack.features.6'),
            this.$t('pricing.jetpack.features.7'),
            this.$t('pricing.jetpack.features.8'),
          ],
          options: []
        }
      ];
    },
    carouselPaddingStyle() {
      return {
        paddingLeft: this.containerPadding + 'px',
        paddingRight: this.containerPadding + 'px',
      };
    }
  },
  mounted() {
    this.$nextTick(this.updatePadding);
    window.addEventListener('resize', this.updatePadding);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updatePadding);
  },
  methods: {
    toggleOptions(i) {
      // Correction pour Vue 3 : on modifie le tableau de façon réactive
      this.optionsOpen = this.optionsOpen.map((open, idx) => idx === i ? !open : open);
    },
    updatePadding() {
      const carousel = this.$refs.carousel;
      if (!carousel) return;
      const containerWidth = carousel.offsetWidth;
      const card = carousel.querySelector('.pricing-card');
      if (!card) return;
      const cardWidth = card.offsetWidth;
      this.cardWidth = cardWidth;
      this.containerPadding = Math.max(0, (containerWidth - cardWidth) / 2);
    },
    onScroll() {
      const carousel = this.$refs.carousel;
      const card = carousel.querySelector('.pricing-card');
      if (!card) return;
      const cardWidth = card.offsetWidth + this.gap;
      const scrollLeft = carousel.scrollLeft;
      const center = scrollLeft + carousel.offsetWidth / 2;
      let index = Math.round((center - cardWidth / 2 - this.containerPadding) / cardWidth);
      index = Math.max(0, Math.min(index, this.cards.length - 1));
      this.currentIndex = index;
    },
    scrollToCard(i) {
      const carousel = this.$refs.carousel;
      const card = carousel.querySelector('.pricing-card');
      if (!card) return;
      const cardWidth = card.offsetWidth + this.gap;
      // Ajout du padding gauche pour corriger le décalage
      const left = i * cardWidth - (carousel.offsetWidth - cardWidth) / 2 + this.containerPadding;
      carousel.scrollTo({ left, behavior: 'smooth' });
      setTimeout(() => this.onScroll(), 400);
    },
    chooseOffer(i) {
      const card = this.cards[i];
      // Préparer les infos à transmettre
      const offerInfo = {
        offer: card.title,
        service: card.service,
        features: card.features,
        options: card.options
      };
      // Stocker dans le localStorage pour récupération sur la page contact
      localStorage.setItem('selectedOffer', JSON.stringify(offerInfo));
      // Rediriger vers la page contact
      this.$router.push('/lets-talk');
    },
  },
  watch: {
    '$i18n.locale'() {
      this.currentIndex = 0;
      this.$nextTick(() => {
        this.updatePadding();
        this.scrollToCard(0);
      });
    }
  }
};
</script>

<style scoped>
.pricing-page {
  padding: 0px 0 0px 0;
}
.big-h1 {
  text-align: center;
  margin-bottom: 40px;
}
.pricing-list {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: center;
}
.carousel-pricing {
  display: flex;
  flex-direction: row;
  gap: 24px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  padding-bottom: 25px;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  align-items: stretch;
  box-sizing: border-box;
  padding-top: 50px; /* Ajout d'un margin-top pour absorber le zoom */
}
.carousel-pricing::-webkit-scrollbar {
    display: none; /* Hides the scrollbar */
}
.pricing-card {
  position: relative;
  flex: 0 0 350px;
  scroll-snap-align: center;
  margin-bottom: 0;
  opacity: 0.6;
  transform: scale(0.92);
  transition: all 0.3s;
  background: rgba(82, 148, 255, 0.04);
  border-radius: 24px;
  border: 1px solid rgba(82, 149, 255, 0.3);
  box-shadow: 0 4px 24px rgba(0,0,0,0.07);
  padding: 32px 28px 24px 28px;
  height: 100%;
/*   max-height: 600px; */
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
}
.pricing-card.active {
  opacity: 1;
  transform: scale(1.05);
  box-shadow: 0 8px 32px rgba(82,149,255,0.18);
  z-index: 2;
}
.pricing-card.inactive {
  opacity: 0.35;
  filter: blur(1.5px) grayscale(0.2);
  z-index: 1;
  transition: all 0.3s;
}
.pricing-card h2 {
  font-size: 1.4rem;
  margin-bottom: 18px;
  color: #5295FF;
  font-weight: 700;
}
.pricing-card .priceText {
  color: #767676;
  font-size: 1.1rem;
  font-weight: 100;
}
.pricing-card ul {
  margin: 0 0 10px 0;
  padding-left: 18px;
}
.pricing-card ul.options {
  margin-bottom: 0;
  color: #666;
  font-size: 0.98rem;
}
.pricing-card strong {
  margin-top: 10px;
  margin-bottom: 2px;
  display: block;
  color: #5295FF;
}
@media (max-width: 900px) {
  .pricing-list {
    flex-direction: column;
    align-items: center;
  }
  .pricing-card {
    max-width: 95vw;
    min-width: unset;
  }
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.header2 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.price {
  font-size: 50px;
  font-weight: 700;
}
.serviceTitle {
    font-size: 40px;
    text-align: center;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.titlePack {
  margin-top: 2px;
  font-size: 0.98rem;
  padding: 1px 14px;
  color: #fff;
  background: linear-gradient(129deg,rgba(122, 240, 252, 1) 0%, rgba(82, 149, 255, 1) 100%);
  border-radius: 20px;
  box-shadow: inset 0px 0px 3.24px 0px rgba(82, 149, 255, 0.24);
}
.features {
  margin-top: 20px;
  font-size: 17px;
}
.options {
  margin-top: 20px;
  width: 100%;
    font-size: 17px;
}
ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    text-justify: center;
}
.carousel-bullets {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 18px;
}
.bullet {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #d0d8f7;
  cursor: pointer;
  transition: background 0.2s;
}
.bullet.active {
  background: #5295FF;
}
.features ul, .options ul {
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
}
.features li, .options li {
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
}
.arrow {
  display: inline-block;
  margin-left: 8px;
  transition: transform 0.2s;
}
.arrow.open {
  transform: rotate(180deg);
}
.fade-enter-active, .fade-leave-active {
  transition: max-height 0.3s cubic-bezier(0.4,0,0.2,1), opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
.fade-enter-to, .fade-leave {
  max-height: 500px;
  opacity: 1;
  overflow: hidden;
}
.maxwidth {
  max-width: 1920px;
  margin-left: 4.7vw !important;
  margin-right: 4.7vw !important;
}
.bestseller-tag {
  position: absolute;
  top: 16px;
  right: 16px;
  background: linear-gradient(129deg,rgba(122, 240, 252, 1) 0%, rgba(82, 149, 255, 1) 100%);
  color: #fff;
  padding: 4px 12px;
  border-radius: 12px;
/*   font-size: 0.9rem;
  font-weight: 700; */
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
  z-index: 10;
}
@media (max-width: 700px) {
    .priceText {
        font-size: 1rem;
    }
    .serviceTitle {
        font-size: 1.2rem;
    }
    .titlePack {
        font-size: 0.9rem;
    }
    .price {
        font-size: 40px;
    }
    .options li, .features {
        font-size: 14px;
    }
    .pricing-card {
          max-width: 300px;
    }
    .bestseller-tag {
  font-size: 10px;
    }
}
.choose-offer-btn {
  margin-top: 28px;
  width: 100%;
  padding: 14px 0;
  background: linear-gradient(129deg,rgba(122, 240, 252, 1) 0%, rgba(82, 149, 255, 1) 100%);
  color: #fff;
  font-size: 1.08rem;
  font-weight: 700;
  border: none;
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(82,149,255,0.12);
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
}
.choose-offer-btn:hover {
  background: linear-gradient(129deg,rgba(82, 149, 255, 1) 0%, rgba(122, 240, 252, 1) 100%);
  transform: translateY(-2px) scale(1.03);
}
</style>
